// extracted by mini-css-extract-plugin
export default {"emptyInfoWrapper":"EmptyTagsListInfo_emptyInfoWrapper__wHA+v"};